/*
 * <collection-modal> — a self-contained trigger + dialog pair.
 * The trigger (a button with aria-haspopup="dialog") opens the dialog that
 * holds the collection's products. Reuses the theme's global trapFocus /
 * removeTrapFocus helpers (defined in global.js) for accessibility.
 */
if (!customElements.get('collection-modal')) {
  customElements.define(
    'collection-modal',
    class CollectionModal extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('[aria-haspopup="dialog"]');
        this.dialog = this.querySelector('[data-dialog]');
        this.panel = this.querySelector('.collections-grid-modal__panel');

        if (!this.trigger || !this.dialog) return;

        this.trigger.addEventListener('click', this.open.bind(this));

        this.querySelectorAll('[data-modal-close]').forEach((element) => {
          element.addEventListener('click', this.close.bind(this));
        });

        this.addEventListener('keyup', (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
        });
      }

      open() {
        this.dialog.removeAttribute('hidden');
        this.setAttribute('open', '');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');

        if (typeof trapFocus === 'function') {
          trapFocus(this.panel || this.dialog, this.panel || this.dialog);
        }
      }

      close() {
        if (!this.hasAttribute('open')) return;

        this.dialog.setAttribute('hidden', '');
        this.removeAttribute('open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.trigger);
        } else {
          this.trigger.focus();
        }
      }
    }
  );
}
